import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isLoggedIn) {
    // Jika belum login, redirect ke halaman login
    // Kirimkan lokasi saat ini agar bisa kembali setelah login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Jika sudah login, tampilkan komponen anak (halaman yang diminta)
  return children;
}

export default ProtectedRoute;